<template>
  <v-dialog v-model="dialog" persistent max-width="560px">
    <v-card v-if="dialog" class="user-delete-modal">
      <v-card-title class="headline">
        <h1 class="ma-0">Excluir usuário</h1>
        <v-spacer></v-spacer>
        <v-btn icon flat class="ma-0" @click="close">
          <i class="fal fa-times"></i>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="user-delete-body">
        <!-- Conferencia visual do usuario selecionado -->
        <div class="user-check pa-3 br-4 mb-3">
          <h3 class="ma-0 fw-600">{{ person.name }}</h3>
          <small class="d-block">CPF: {{ cpfFormatter(person.cpf) }}</small>
          <small class="d-block">E-mail: {{ person.email }}</small>
        </div>

        <!-- Aviso do que acontece -->
        <div class="delete-warning pa-2 br-4 mb-3">
          <p class="fw-600 mb-1">
            <i class="fal fa-exclamation-triangle mr-1"></i>Esta ação é irreversível. Ao confirmar:
          </p>
          <ul class="pl-4 ma-0">
            <li>Os dados pessoais serão anonimizados na base (nome, CPF, e-mail, telefone, endereço).</li>
            <li>Assinaturas ativas em Asaas / Vindi / Pagar.me serão canceladas.</li>
            <li>O histórico de doações e recibos é preservado para fins fiscais, mas passará a aparecer como "Doador excluído" nos relatórios.</li>
          </ul>
        </div>

        <!-- Motivo (obrigatorio, min 20 chars) -->
        <v-textarea
          class="mt-4"
          v-model="reason"
          label="Motivo da exclusão"
          placeholder="Descreva o motivo da exclusão (mínimo 20 caracteres)"
          counter="2000"
          maxlength="2000"
          rows="6"
          box
          :hint="reason && reason.trim().length < minReasonLength
            ? 'Informe ao menos ' + minReasonLength + ' caracteres (' + reason.trim().length + '/' + minReasonLength + ')'
            : ''"
          persistent-hint
        ></v-textarea>

        <!-- Contato/origem do pedido (opcional) -->
        <v-text-field
          class="mt-3"
          v-model="requestedBy"
          label="Solicitado por (opcional)"
          placeholder="E-mail do titular, ticket, etc."
        ></v-text-field>

        <!-- Duplo confirm -->
        <v-checkbox
          v-model="irreversibleChecked"
          label="Estou ciente que a ação é irreversível"
          color="error"
          hide-details
          class="mt-2"
        ></v-checkbox>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn flat round class="btn btn-default px-4" @click="close">Cancelar</v-btn>
        <v-btn
          flat
          round
          class="btn btn-primary px-4"
          :disabled="!canDelete"
          @click="confirmDelete"
        >Excluir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script type="plain/text">
import UserService from "@/scripts/services/user.service";
import FormatterHelper from "@/scripts/helpers/formatter.helper";

const MIN_REASON_LENGTH = 20;

export default {
  data() {
    return {
      dialog: false,
      userService: new UserService(),
      person: {},
      reason: "",
      requestedBy: "",
      irreversibleChecked: false,
      minReasonLength: MIN_REASON_LENGTH,
      submitting: false
    };
  },
  computed: {
    canDelete() {
      return (
        !this.submitting &&
        this.irreversibleChecked &&
        !!this.reason &&
        this.reason.trim().length >= this.minReasonLength
      );
    }
  },
  methods: {
    cpfFormatter(cpf) {
      return new FormatterHelper().formatCpf(cpf);
    },
    open(person) {
      this.person = person || {};
      this.reason = "";
      this.requestedBy = "";
      this.irreversibleChecked = false;
      this.submitting = false;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirmDelete() {
      if (!this.canDelete) return;
      this.submitting = true;

      this.userService
        .anonymizeUser(this.person.userId, this.reason.trim(), this.requestedBy)
        .then(
          function(result) {
            const message = result && result.alreadyAnonymized
              ? "Usuário já estava anonimizado."
              : `Usuário excluído com sucesso! Protocolo de exclusão #${result ? result.deletionLogId : ""}`;
            this.$store.commit("SET_SNACKBAR_SUCCESS_MESSAGE", message);
            this.$emit("refresh");
            this.close();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.submitting = false;
            const message = error && error.errorMessage
              ? error.errorMessage
              : "Não foi possível excluir o usuário. Tente novamente ou contate o administrador.";
            this.$store.commit("SET_SNACKBAR_MESSAGE", message);
          }.bind(this)
        );
    }
  }
};
</script>

<style lang="css" scoped>
.user-delete-modal h1 {
  font-size: 22px;
}
/* O tema global tem `.v-card__text { display: flex; padding: 0 !important }`,
   o que jogava o conteudo em colunas lado a lado. Forcamos empilhamento vertical. */
.user-delete-body {
  display: block !important;
  flex: none !important;
  max-height: 60vh;
  overflow-y: auto;
  padding: 16px 24px !important;
}
.user-delete-body > * {
  width: 100%;
}
.user-check {
  background: #f5f6fa;
  border: 1px solid #e0e2ec;
}
.delete-warning {
  background: #fff5f5;
  border: 1px solid #f2c2c2;
  color: #8a1f1f;
  font-size: 12px;
  line-height: 1.35;
}
.delete-warning p {
  font-size: 12.5px;
}
.delete-warning ul li {
  margin-bottom: 2px;
}
</style>
